import { PrintViewContainer } from "@/components/printView";

export function PrintableReportPage() {
  return <PrintViewContainer />;
}

export default PrintableReportPage;
